var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 11.5C21.0581 12.8199 20.7498 14.1219 20.1547 15.3C19.4491 16.7118 18.3644 17.8992 17.0221 18.7293C15.6798 19.5594 14.1329 19.9994 12.5547 20C11.2348 20.0035 9.9328 19.6951 8.75469 19.1L3.05469 21L4.95469 15.3C4.35962 14.1219 4.05125 12.8199 4.05469 11.5C4.0553 9.92179 4.4953 8.37488 5.32541 7.03258C6.15551 5.69028 7.34294 4.6056 8.75469 3.90003C9.9328 3.30496 11.2348 2.99659 12.5547 3.00003H13.0547C15.139 3.11502 17.1077 3.99479 18.5838 5.47089C20.0599 6.94699 20.9397 8.91568 21.0547 11V11.5Z",
    stroke: "#A7A7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.722c74dff8298c44c3651c8d18a42d53.svg";
export { ForwardRef as ReactComponent };